
const _cache = new Map();

/**
 * Prefetches url
 * @param url
 * @param maxAge
 * @return Promise<Response>
 */
export function prefetch(url, maxAge = 3600) {
    const cacheEntry = _cache.get(url);

    console.log("prefetch", {url, cacheEntry, expired: cacheEntry?.maxAge + cacheEntry?.created > Date.now()});

    // No entry exists or it is expired
    if (!cacheEntry || cacheEntry?.maxAge * 1000 + cacheEntry?.created < Date.now()) {
        const promise = fetch(url).then(res => {
            _cache.set(url, {
                ..._cache.get(url),
                response: res,
            });
            return res;
        });

        // Register new entry with promise
        _cache.set(url, {
            promise,
            maxAge,
            created: Date.now(),
        });
    }

    console.log("prefetchReturn", _cache.get(url));

    return _cache.get(url).promise;
}

/**
 * Invalidates all url entries that start with pattern
 * @param pattern
 */
export function prefetchInvalidate(pattern) {
    const regexp = new RegExp(`^${pattern}`);

    console.log("prefetchInvalidate", pattern, regexp);

    for (const [key] of _cache.entries()) {
        if (key.match(regexp)) {
            console.log("delete", key);
            _cache.delete(key);
        } else {
            console.log("keep", key);
        }
    }
}



export function registerRequest(url, response, maxAge = 7200) {
    const entry = {
        response,
        maxAge: maxAge,
        created: Date.now(),
    };
    _cache.set(url, entry);
    return entry;
}
